module.exports = "img/button-text-numbered-list.be2830c.svg";